import styles from './Card.module.css';

// Универсальная карточка
// Варианты: 'default' | 'team' | 'philosophy'
const Card = ({ children, variant = 'default', className = '' }) => {
  const classes = [styles.card, styles[variant], className].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
};

export default Card;
